import { Component, Directive, ElementRef, TemplateRef, forwardRef, Input, OnInit, Renderer2, ViewChild, ContentChild, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { InputTextLabelDirective, InputTextAddonLeftDirective, InputTextAddonRightDirective } from './input-text.directive';
export class InputTextComponent implements ControlValueAccessor, OnInit {
public value: any;
private listener: Function;
private onChange: Function;
private onTouched: Function;

   addonLeft: string;
   addonRight: string;
   id: string | number = new Date().valueOf();
   inputColor: string;
   inputFontColor: string;
   isDisabled: boolean;
   label: string;
   placeholder: string;
   size: string;
   wrapperClasses = 'form-group';

   inputElement: ElementRef;
public inputTextLabelDirective: InputTextLabelDirective;
public inputTextAddonLeftDirective: InputTextAddonLeftDirective;
public inputTextAddonRightDirective: InputTextAddonRightDirective;
/**
 * \@method constructor
 * @param {?} changeDetectorRef
 * @param {?} renderer2
 */
constructor(
private changeDetectorRef: ChangeDetectorRef,
private renderer2: Renderer2
  ) {}
/**
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit() {
    //this.ngZone.runOutsideAngular(() => { #BUG
      this.listener = this.renderer2.listen(this.inputElement.nativeElement, 'input', (event: Event) => {
        this.onChange(( /** @type {?} */((<HTMLInputElement>event.target))).value);
        this.changeDetectorRef.detectChanges();
      });
      this.renderer2.listen(this.inputElement.nativeElement, 'blur', (event: Event) => {
        this.onTouched();
        this.changeDetectorRef.detectChanges();
      });
    //});
  }
/**
 * \@method ngOnDestroy
 * @return {?}
 */
ngOnDestroy() {
    if(this.listener) {
      this.listener();
    }
  }
/**
 * [registerOnChange description]
 * \@method registerOnChange
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: Function): void {
    this.onChange = fn;
  }
/**
 * [registerOnTouched description]
 * \@method registerOnTouched
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: Function): void {
    this.onTouched = fn;
  }
/**
 * [setDisabledState description]
 * \@method setDisabledState
 * @param {?} isDisabled
 * @return {?}
 */
setDisabledState(isDisabled: boolean): void {
    this.renderer2.setProperty(this.inputElement.nativeElement, 'disabled', isDisabled);
  }
/**
 * [writeValue description]
 * \@method writeValue
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {
    if(value) {
      this.value = value;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-input-text',
  template: `
    <div [ngClass]="wrapperClasses" [mkColor]="inputColor" mkColorPrefix="has">
      <label *ngIf="addonLeft || inputTextLabelDirective" for="{{id}}">
        {{label}}
        <ng-content select="mk-input-text-label"></ng-content>
      </label>
      <div class="input-group">
        <span *ngIf="addonLeft || inputTextAddonLeftDirective" class="input-group-addon" [mkColor]="inputColor" mkColorProperty="border-color">
          {{addonLeft}}
          <ng-content select="mk-input-text-addon-left"></ng-content>
        </span>
        <input #inputElement type="text" class="form-control" [ngClass]="size === 'small' ? 'input-sm' : size === 'large' ? 'input-lg': ''" id="{{id}}" placeholder="{{placeholder}}" [(ngModel)]="value" [disabled]="isDisabled" [mkColor]="inputColor" mkColorProperty="border-color" [mkFontColor]="inputFontColor">
        <span *ngIf="addonRight || inputTextAddonRightDirective" class="input-group-addon" [mkColor]="inputColor" mkColorProperty="border-color">
          {{addonRight}}
          <ng-content select="mk-input-text-addon-right"></ng-content>
        </span>
      </div>
    </div>
  `,
  styles: [`

  `],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputTextComponent),
    multi: true
  }]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'addonLeft': [{ type: Input },],
'addonRight': [{ type: Input },],
'id': [{ type: Input },],
'inputColor': [{ type: Input },],
'inputFontColor': [{ type: Input },],
'isDisabled': [{ type: Input },],
'label': [{ type: Input },],
'placeholder': [{ type: Input },],
'size': [{ type: Input },],
'wrapperClasses': [{ type: Input },],
'inputElement': [{ type: ViewChild, args: ['inputElement', ] },],
'inputTextLabelDirective': [{ type: ContentChild, args: [InputTextLabelDirective, ] },],
'inputTextAddonLeftDirective': [{ type: ContentChild, args: [InputTextAddonLeftDirective, ] },],
'inputTextAddonRightDirective': [{ type: ContentChild, args: [InputTextAddonRightDirective, ] },],
};
}

function InputTextComponent_tsickle_Closure_declarations() {
/** @type {?} */
InputTextComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputTextComponent.ctorParameters;
/** @type {?} */
InputTextComponent.propDecorators;
/** @type {?} */
InputTextComponent.prototype.value;
/** @type {?} */
InputTextComponent.prototype.listener;
/** @type {?} */
InputTextComponent.prototype.onChange;
/** @type {?} */
InputTextComponent.prototype.onTouched;
/** @type {?} */
InputTextComponent.prototype.addonLeft;
/** @type {?} */
InputTextComponent.prototype.addonRight;
/** @type {?} */
InputTextComponent.prototype.id;
/** @type {?} */
InputTextComponent.prototype.inputColor;
/** @type {?} */
InputTextComponent.prototype.inputFontColor;
/** @type {?} */
InputTextComponent.prototype.isDisabled;
/** @type {?} */
InputTextComponent.prototype.label;
/** @type {?} */
InputTextComponent.prototype.placeholder;
/** @type {?} */
InputTextComponent.prototype.size;
/** @type {?} */
InputTextComponent.prototype.wrapperClasses;
/** @type {?} */
InputTextComponent.prototype.inputElement;
/** @type {?} */
InputTextComponent.prototype.inputTextLabelDirective;
/** @type {?} */
InputTextComponent.prototype.inputTextAddonLeftDirective;
/** @type {?} */
InputTextComponent.prototype.inputTextAddonRightDirective;
/** @type {?} */
InputTextComponent.prototype.changeDetectorRef;
/** @type {?} */
InputTextComponent.prototype.renderer2;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
